import { render, staticRenderFns } from "./AccessBase.vue?vue&type=template&id=151d9460&scoped=true"
import script from "./AccessBase.vue?vue&type=script&lang=js"
export * from "./AccessBase.vue?vue&type=script&lang=js"
import style0 from "./AccessBase.vue?vue&type=style&index=0&id=151d9460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d9460",
  null
  
)

export default component.exports